<template>
  <div class="flex flex-col gap-6 md:flex-row md:items-start">
    <div class="flex flex-col gap-6 md:w-1/2 md:gap-3">
      <div class="flex flex-row overflow-hidden rounded-xl bg-primary-50 py-2">
        <div class="flex w-1/2 flex-col items-center">
          <UiSkeleton class="h-6 w-10" />
          <UiSkeleton class="mt-2 h-6 w-20" />
        </div>
        <div class="flex w-1/2 flex-col items-center">
          <UiSkeleton class="h-6 w-10" />
          <UiSkeleton class="mt-2 h-6 w-24" />
        </div>
      </div>
      <div class="rounded-xl bg-primary-50 p-7 pr-0 md:p-12">
        <UiSkeleton class="my-2 h-6 w-40" />
        <UiSkeleton class="my-4 h-10 w-48" />
        <div class="mx-3 mb-4 mt-10 flex flex-row">
          <div class="flex w-2/5 items-start md:w-32">
            <UiSkeleton class="size-24" />
          </div>
          <div class="ml-4 flex w-full flex-col">
            <UiSkeleton class="h-6 w-60" />
            <UiSkeleton class="my-2 h-6 w-20" />
            <div class="mt-3 flex flex-row justify-between">
              <UiSkeleton class="h-8 w-32" />
              <UiSkeleton class="size-8" />
            </div>
          </div>
        </div>
        <UiDivider />
        <div class="mx-3 mb-4 mt-8 flex flex-row">
          <div class="flex w-2/5 items-start md:w-32">
            <UiSkeleton class="size-24" />
          </div>
          <div class="ml-4 flex w-full flex-col">
            <UiSkeleton class="h-6 w-60" />
            <UiSkeleton class="my-2 h-6 w-20" />
            <div class="mt-3 flex flex-row justify-between">
              <UiSkeleton class="h-8 w-32" />
              <UiSkeleton class="size-8" />
            </div>
          </div>
        </div>
        <UiDivider />
        <UiSkeleton class="mt-5 h-8 w-32" />
      </div>
    </div>
    <div class="w-full rounded-xl bg-white p-7 md:w-1/2 md:p-12">
      <div class="mb-3 flex flex-row items-baseline justify-between">
        <UiSkeleton class="h-8 w-60" />
        <UiSkeleton class="my-2 h-8 w-20" />
      </div>
      <div class="flex flex-row items-baseline justify-between">
        <UiSkeleton class="h-6 w-40" />
        <UiSkeleton class="h-6 w-28" />
      </div>
      <div class="flex flex-row items-baseline justify-between">
        <UiSkeleton class="h-4 w-28" />
        <UiSkeleton class="my-2 h-4 w-20" />
      </div>
      <div class="mb-4 flex flex-row items-baseline justify-between">
        <UiSkeleton class="h-4 w-20" />
        <UiSkeleton class="h-4 w-14" />
      </div>
      <UiDivider />
      <div class="my-4 flex">
        <UiSkeleton class="h-10 w-full" />
        <UiSkeleton class="ml-3 h-10 w-20" />
      </div>
      <UiDivider />
      <div class="mb-3 flex flex-row items-baseline justify-between">
        <UiSkeleton class="h-8 w-14" />
        <UiSkeleton class="my-2 h-8 w-20" />
      </div>
      <UiDivider />
      <UiSkeleton class="mt-3 h-10 w-full" />
    </div>
  </div>
</template>
